// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const excadrill: PokeData = {
  "id": 530,
  "name": "excadrill",
  "height": 7,
  "weight": 404,
  "base_experience": 178,
  "types": [
    PokeType.GROUND,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "horn-drill",
    "earthquake",
    "fissure",
    "dig",
    "fury-swipes",
    "rock-slide",
    "slash",
    "mud-slap",
    "sandstorm",
    "rapid-spin",
    "metal-claw",
    "mud-sport",
    "crush-claw",
    "hone-claws",
    "drill-run",
    "rototiller"
  ],
  "moves": [
    "scratch",
    "earthquake",
    "fissure",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "metal-claw",
    "rototiller",
    "bonemerang",
    "metal-sound",
    "behemoth-bash",
    "metal-rush",
    "steel-beam"
  ],
  "evolution_chain": {
    "id": 270,
    "item": null,
    "species": [
      {
        "name": "drilbur",
        "order": 530,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "excadrill",
        "order": 531,
        "types": [
          PokeType.GROUND,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 529,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 114,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
